import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ExceptionHandlerService } from '../exceptionhandler/exception.handler.service';
import {catchError, Observable} from 'rxjs';
import {map, shareReplay} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class UserService {
  static USER_BASE_URL = '/api';

  constructor(
    private http: HttpClient,
    private exceptionService: ExceptionHandlerService
  ) {}

  getAdminStatus() {
    return this.http
      .get<boolean>(`${UserService.USER_BASE_URL}/system/isAdmin`)
      .pipe(catchError(this.exceptionService.handleError<boolean>()));
  }

  getUserInfo(): Observable<any> {
    return this.http
      .get<any>(`${UserService.USER_BASE_URL}/system/user`) // Verifica el endpoint con tu Swagger
      .pipe(
        catchError(this.exceptionService.handleError<any>())
      );
  }

  getUserEmail(): Observable<string | null> {
    return this.http.get<any>(`${UserService.USER_BASE_URL}/system/user`).pipe(
      map(data => {
        return data?.tokenAttributes?.preferred_username || null;
      }),
      shareReplay(1)
    );
  }
}
